module.exports = __webpack_public_path__ + "img/4.ba955846.jpg";